import { useEffect, useState } from "react"
import { useEventCallback } from "src/hooks/useEventCallback"
import { useWindowEvent } from "src/hooks/useWindowEvent"
import { breakpoints, matchMinBreakpoint } from "src/utilities/responsive"

export function useIsMinBreakpoint(breakpoint: keyof typeof breakpoints) {
  const [matches, setMatches] = useState(false)

  const updateMatches = useEventCallback(() => {
    const newMatches = matchMinBreakpoint(breakpoint).matches

    if (newMatches !== matches) {
      setMatches(newMatches)
    }
  })

  useWindowEvent("resize", updateMatches)
  useEffect(updateMatches, [])

  return matches
}
